import { TelemetryFields } from '@/observability';

export type ApiError = {
  httpStatus?: number;
  code?: string;
  message?: string;
  field?: string;
  correlationId?: string;
  raw: unknown;
};

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const asText = (value: unknown): string | undefined => (typeof value === 'string' && value.trim() !== '' ? value : undefined);

const asStatus = (value: unknown): number | undefined => (typeof value === 'number' && Number.isFinite(value) ? value : undefined);

export function unwrapApiError(raw: unknown): ApiError {
  try {
    if (raw instanceof Error) {
      return { message: raw.message, raw };
    }
    if (!isRecord(raw)) {
      return { message: asText(raw), raw };
    }

    const envelope = isRecord(raw.json) && Array.isArray(raw.json.errors) ? raw.json.errors[0] : undefined;
    const serverError = isRecord(envelope) ? envelope : undefined;

    return {
      httpStatus: asStatus(raw.httpStatus),
      code: asText(serverError?.code),
      message: asText(serverError?.message) ?? asText(raw.field) ?? asText(raw.text) ?? asText(raw.message),
      field: asText(serverError?.field) ?? asText(raw.field),
      correlationId: asText(raw.correlationId),
      raw,
    };
  } catch {
    return { raw };
  }
}

export const apiErrorTelemetryFields = (apiError: ApiError): TelemetryFields => ({
  correlationId: apiError.correlationId,
  errorCode: apiError.code,
  errorMessage: apiError.message,
  errorType: 'ApiError',
  httpStatus: apiError.httpStatus,
});
